// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".overflow-y-scroll[data-v-0f7e3d0f]{max-height:200px}", "",{"version":3,"sources":["webpack://./resources/assets/js/components/users/UsersSwitch.vue"],"names":[],"mappings":"AACA,oCACE,gBAAF","sourcesContent":["\n.overflow-y-scroll {\n  max-height: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
